import { render, staticRenderFns } from "./ListJobListingCandidate.vue?vue&type=template&id=3973c2df"
import script from "./ListJobListingCandidate.vue?vue&type=script&lang=js"
export * from "./ListJobListingCandidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListJobListingCandidate.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3973c2df')) {
      api.createRecord('3973c2df', component.options)
    } else {
      api.reload('3973c2df', component.options)
    }
    module.hot.accept("./ListJobListingCandidate.vue?vue&type=template&id=3973c2df", function () {
      api.rerender('3973c2df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/candidates/views/ListJobListingCandidate.vue"
export default component.exports